import generateAdjustedEventTraits from 'src/js/modules/element-settings/helpers/generate-adjusted-event-traits';
import attributes from '../constants/attributes';

const getTraitName = (attribute) => {
  switch (attribute) {
    case attributes.SURFACE: {
      return 'Surfaces';
    }

    case attributes.HORIZONTAL_ALIGNMENT: {
      return 'HorizontalContentAlignment';
    }

    case attributes.VERTICAL_ALIGNMENT: {
      return 'VerticalContentAlignment';
    }

    case attributes.BORDER_TOP_LEFT_RADIUS:
    case attributes.BORDER_TOP_RIGHT_RADIUS:
    case attributes.BORDER_BOTTOM_LEFT_RADIUS:
    case attributes.BORDER_BOTTOM_RIGHT_RADIUS: {
      return 'Corners';
    }

    case attributes.PADDING_TOP:
    case attributes.PADDING_BOTTOM:
    case attributes.PADDING_LEFT:
    case attributes.PADDING_RIGHT:
    case attributes.COLUMN_GAP:
    case attributes.ROW_GAP: {
      return 'Spacing';
    }

    case attributes.LAYOUT: {
      return 'PerRow';
    }

    case attributes.HORIZONTAL_ALIGN:
    case attributes.VERTICAL_ALIGN: {
      return 'Alignment';
    }

    default: {
      return attribute;
    }
  }
};

const getAdjustedTraits = ({ prefix, modifiedAttributes }) => {
  const adjustedTraits = modifiedAttributes.reduce((accTraits, attribute) => {
    const currentTraitName = getTraitName(attribute);
    const currentTraits = generateAdjustedEventTraits(prefix, currentTraitName, true);

    return {
      ...accTraits,
      ...currentTraits,
    };
  }, {});

  return adjustedTraits;
};

export default getAdjustedTraits;
